import { MessageBox } from "element-ui";

const createTeamPrompt = function (msg, title, canClose = false) {
  return new Promise((resolve, reject) => {
    MessageBox.prompt(msg || "", title || "创建属于您的团队", {
      center: true,
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPattern: /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[0-9a-zA-Z]){2,10}$/,
      inputErrorMessage: "请输入不含特殊字符2-10位团队名称",
      inputPlaceholder: "请输入您的团队名称",
      showCancelButton: canClose,
      closeOnClickModal: canClose,
      closeOnPressEscape: canClose,
      closeOnHashChange: canClose,
      roundButton: false,
      showClose: canClose,
      inputValidator: (val) => {
        if (val?.length > 0) {
          return true;
        } else {
          return false;
        }
      },
    })
      .then(({ value }) => {
        resolve(value);
      })
      .catch(() => {
        reject();
      });
  });
};
const switchTeamPrompt = function (msg, title) {
  return new Promise((resolve, reject) => {
    MessageBox.alert(msg, title || "提示", {
      confirmButtonText: "返回我的团队",
      callback: (action) => {
        window.location.reload();
      },
    });
  });
};
export default {
  createTeamPrompt,
  switchTeamPrompt,
};
